import {compose, withHandlers, lifecycle} from 'recompose';

import {
  constructCallEventData,
  eventNames as defaultEventNames
} from '../events';

function handleEvent(props) {
  return (name, data) => {
    const {onEvent} = props;

    if (typeof onEvent === 'function') {
      onEvent(name, data);
    }
  };
}

export default compose(
  withHandlers({handleEvent}),
  lifecycle({
    componentDidMount() {
      this.eventNames = Object.assign({}, defaultEventNames, this.props.eventNames);
    },
    componentWillReceiveProps(nextProps) {
      const {
        currentUser,
        call,
        callInstance
      } = nextProps;
      const prevCall = this.props.call;

      try {
        if (call) {
          // Check if this is a new initiated call
          if (call.isInitiated && (!prevCall || !prevCall.isInitiated)) {
            // Emit the event
            nextProps.handleEvent(
              this.eventNames.CALLS_CREATED,
              constructCallEventData({
                callInstance
              })
            );
          }

          if (call.isConnected && !prevCall.isConnected) {
            // New call is connected, emit event
            nextProps.handleEvent(
              this.eventNames.CALLS_CONNECTED,
              constructCallEventData({
                callInstance
              })
            );
          }
        }

        if (!call && prevCall) {
          nextProps.handleEvent(
            this.eventNames.CALLS_DISCONNECTED,
            constructCallEventData({
              callInstance: prevCall.instance,
              actor: currentUser
            })
          );
        }
      }
      catch (e) {
        // Do nothing
      }
    }
  })
);
